export default __webpack_public_path__ + "static/media/02.a47fa788.svg";